var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRtlVersion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 168,
    viewBox: "0 0 300 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_928_2525)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 168,
    rx: 20,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 196,
    rx: 2,
    transform: "matrix(-1 0 0 1 315 -14)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 83,
    rx: 2,
    transform: "matrix(-1 0 0 1 253 76)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 71,
    width: 77,
    height: 45,
    rx: 2,
    transform: "rotate(-180 88 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 71,
    width: 76,
    height: 45,
    rx: 2,
    transform: "rotate(-180 170 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253,
    y: 71,
    width: 77,
    height: 45,
    rx: 2,
    transform: "rotate(-180 253 71)",
    fill: "#CBE6C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.158 107.828H114.173C116.021 107.828 117.609 108.105 118.938 108.658C120.277 109.212 121.306 110.031 122.025 111.115C122.745 112.2 123.104 113.534 123.104 115.116C123.104 116.411 122.883 117.523 122.44 118.453C122.009 119.372 121.395 120.141 120.598 120.761C119.812 121.369 118.888 121.856 117.825 122.222L116.248 123.052H108.412L108.379 119.167H114.206C115.08 119.167 115.805 119.012 116.381 118.702C116.956 118.392 117.388 117.961 117.676 117.407C117.975 116.854 118.124 116.212 118.124 115.481C118.124 114.707 117.98 114.037 117.692 113.473C117.405 112.908 116.967 112.477 116.381 112.178C115.794 111.879 115.058 111.729 114.173 111.729H110.139V132H105.158V107.828ZM118.672 132L113.16 121.226L118.423 121.192L124.001 131.768V132H118.672Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.111 107.828V132H133.147V107.828H138.111ZM145.548 107.828V111.729H125.826V107.828H145.548Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.286 128.115V132H153.117V128.115H165.286ZM154.728 107.828V132H149.747V107.828H154.728Z",
    fill: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 11,
    rx: 2,
    transform: "matrix(-1 0 0 1 253 9)",
    fill: "#CBE6C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_928_2525"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 300,
    height: 168,
    rx: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRtlVersion);
export default __webpack_public_path__ + "static/media/rtl-version.864f660d4e1b186d5744358f427b77a1.svg";
export { ForwardRef as ReactComponent };